import { useEffect, useMemo } from "react";
import { ImagePlus, X } from "lucide-react";

const MAX = 4;
const MAX_MB = 10;

export const PhotoPicker = ({ files, setFiles }) => {
  const previews = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
  useEffect(() => {
    return () => previews.forEach((u) => URL.revokeObjectURL(u));
  }, [previews]);

  const add = (e) => {
    const picked = Array.from(e.target.files || []).filter((f) => f.type.startsWith("image/") && f.size <= MAX_MB * 1024 * 1024);
    setFiles((cur) => [...cur, ...picked].slice(0, MAX));
    e.target.value = "";
  };

  return (
    <div>
      <p className="text-sm font-semibold text-[var(--navy)]">Photos of the job <span className="font-normal text-slate-500">(optional, up to {MAX}, max {MAX_MB} MB each)</span></p>
      <div className="mt-3 flex flex-wrap gap-3">
        {previews.map((u, i) => (
          <div key={u} className="relative h-24 w-24 overflow-hidden rounded-xl border border-slate-200">
            <img src={u} alt={`Selected photo ${i + 1}`} className="h-full w-full object-cover" />
            <button type="button" onClick={() => setFiles(files.filter((_, j) => j !== i))} data-testid={`quote-form-photo-remove-${i}`}
              aria-label={`Remove photo ${i + 1}`} className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-white/90 text-slate-700">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        {files.length < MAX && (
          <label className="flex h-24 w-24 cursor-pointer flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-slate-300 text-slate-500 transition-colors hover:border-[var(--green)] hover:text-[var(--green)]">
            <ImagePlus className="h-6 w-6" />
            <span className="text-xs font-medium">Add photo</span>
            <input type="file" accept="image/*" multiple onChange={add} className="sr-only" data-testid="quote-form-photo-upload-input" />
          </label>
        )}
      </div>
    </div>
  );
};
